<template>
  <div id="result" v-show="resultConfig.page_type">
    <img-v3 class="result-icon" :src="icon[resultConfig.page_type]" />

    <h1 class="result-title">{{resultConfig.tip}}</h1>
    <p class="result-desc" v-html="resultConfig.desc"></p>
    <text-link v-if="resultConfig.text_link" :form-item="resultConfig.text_link" />
    <div class="result-footer" v-if="isFleetAppDriver">
      <span class="result-btn-download" @click="goDriverList">{{ $t("Fleet_start__tmar") }}</span>
    </div>
    <div class="result-footer" v-else-if="showDownload">
      <span class="result-btn-download" @click="goDownLoad">{{ downloadTxt }}</span>
    </div>
    <div class="result-footer" v-else-if="showGoBack">
      <span class="result-btn-download" @click="goBack">{{ goBackTxt }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ends, LOGIN_CONFIG } from "../tools/constant";
import { post } from "../tools/request";
import { showAlertDialog, showLoadingToast } from "../tools/Tip";
import { setTitle } from "../tools/setTitle";
import TextLink from "./base/text-link";
export default {
  components: { TextLink },
  data() {
    return {
      ends,
      icon: {
        checking: require("../images/icon_wait@3x.png"),
        fail: require("../images/icon_fail@3x.png"),
        success: require("../images/icon_success@3x.png")
      },
      resultConfig: {},
      driver_role: 1
    };
  },
  computed: {
    ...mapState(["_ticket", "_cell", "_uuid"]),
    location_country() {
      let up = new URLSearchParams(location.search);
      return up.get("location_country");
    },
    showDownload() {
      //20200319 RU 车头 不再展示下载 or 返回按钮
      if ((this.location_country === "RU" || this.location_country === "UA") && this.driver_role == 2) {
        return false;
      }
      //官网流量，隐藏按钮展示
      if (this.ends.isPC) {
        return false;
      }
      //决定是否下载 端外必下载；端内--1.司机端，提示车头下载fleet；2.fleet端，提示司机车主下载司机端
      if (this.resultConfig.page_type === "success" && !this.ends.inApp) {
        return true;
      } else if (this.resultConfig.page_type === "success" && this.ends.inApp) {
        if (this.location_country === "BR") {
          //巴西只要端外均下载，端内均返回
          return false;
        }
        if (this.ends.isGlobal) {
          if (this.driver_role == 2) {
            return true;
          }
        } else if (this.ends.isFleet) {
          if (this.driver_role == 1) {
            return true;
          }
        }
      }
      return false;
    },
    showGoBack() {
      if ((this.location_country === "RU" || this.location_country === "UA") && this.driver_role == 2) {
        return false;
      }
      //官网流量，隐藏按钮展示
      if (this.ends.isPC) {
        return false;
      }
      //返回功能，必须在端内; 1.司机车主在司机端内--返回正常首页 2.车头在fleet端内--返回车队首页
      if (this.resultConfig.page_type === "success" && this.ends.inApp) {
        if (this.location_country === "BR") {
          //巴西只要端外均下载，端内均返回
          return true;
        }

        if (this.ends.isGlobal) {
          if (this.driver_role == 1) {
            return true;
          }
        } else if (this.ends.isFleet) {
          if (this.driver_role == 2) {
            return true;
          }
        }
      }
      return false;
    },
    downloadTxt() {
      if (this.driver_role == 2) {
        //车头下载fleet端
        return this.$t("下载fleet");
      } else if (this.driver_role == 1) {
        //司机车主下载司机端
        return this.$t("下载按钮");
      }
    },
    goBackTxt() {
      if (this.driver_role == 2) {
        //车头返回车队首页
        return this.$t("返回车队首页");
      } else if (this.driver_role == 1) {
        //司机车主，返回司机端首页
        return this.$t("返回首页");
      }
    },
    isFleetAppDriver() {
      if (this.ends.isFleetApp && this.location_country === 'BR' && this.driver_role == 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    goDriverList() {
      let params = new URLSearchParams(location.search);
      let ticket = params.get('driverLeaderTicket');
      let url = `${this.resultConfig.to[ends.isIOS ? 'ios' : 'android']}${location.search}&ticket=${ticket}`;
      const module = Fusion.loadModule("newPageModule");
        ends.inApp && module.openNewPage({
              url,
              back_to_fleethome: 1,
              tab_index: 2
        });
        !ends.inApp && location.replace(url);
    },
    goDownLoad() {
      if (this.ends.isIOS) {
        if (this.driver_role == 1) {
          location.href = this.resultConfig.to.ios;
        } else if (this.driver_role == 2) {
          location.href = this.resultConfig.to.ios_fleet;
        }
      } else {
        if (this.driver_role == 1) {
          location.href = this.resultConfig.to.android;
        } else if (this.driver_role == 2) {
          location.href = this.resultConfig.to.android_fleet;
        }
      }
    },
    //回到司机主页或者车队首页
    goBack() {
      try {
        let params = new URLSearchParams(location.search);
        let ticket =
          this._ticket || params.get("ticket") || params.get("token");
        let cell = (params.get("cell") || this._cell || "").trim();
        if (cell.substr(0, 1) != "+") {
          let code = (LOGIN_CONFIG[this.location_country] || window.didii18nconfig[this.location_country]).country_calling_code;
          // @20190704 兼容电话号已传递的情况 55、+55
          if (cell.indexOf(code.substr(1)) == 0) {
            code = "+";
          }
          cell = `${code}${cell}`;
        }
        let regSuccess = () => {
          Fusion.registSuccess(
            {
              cell,
              global_phone: cell,
              ticket,
              token: ticket,
              uid: params.get("uid") || this._uuid,
              role: 2
            },
            () => {}
          );
        };

        if (this.driver_role == 1) {
          if (this.location_country === "BR") {
            regSuccess();
          } else {
            //保留墨西哥旧逻辑，区分 enterFrom参数
            if (params.get("enterFrom") === "dlogin") {
              regSuccess();
            } else {
              Fusion.toMainPage({});
            }
          }
        } else if (this.driver_role == 2) {
          if (params.get("enterFrom") === "dlogin") {
            regSuccess();
          } else {
            let module = Fusion.loadModule("PageModule");
            module.toMainPage({ tab: "0" }, () => {});
          }
        }
      } catch (e) {}
    },
    getPageConfig() {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.RESULT_URL, up)
        .then(data => {
          this.resultConfig = data;
          this.driver_role = data.driver_role || 1;
          data.title && setTitle(data.title);
          this.$emit("btn-update");
        })
        .catch(err => {
          showAlertDialog(this);
        })
        .finally(() => {
          this.toast.hide();
           try {
            gtm({ event: "s8ObFinalVerify", Status: this.resultConfig.page_type});
            if(this.resultConfig.page_type === 'success') {
              snaptr('track', 'SIGN_UP', {eventID: Omega.getOmgid()});
              fbq('track', 'SubmitApplication', {eventID: Omega.getOmgid()});
            } else if (this.resultConfig.page_type === 'checking') {
              snaptr('track', 'SUBSCRIBE', {eventID: Omega.getOmgid()});
              fbq('track', 'Subscribe', {eventID: Omega.getOmgid()});
            }
          } catch (e) {}
        });
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeId);
  },
  mounted() {
    // this.getPageConfig();
    this.timeId=setTimeout(this.getPageConfig, 0);
  }
};
</script>
<style lang="scss" scoped>
#result {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 1px;
  user-select: text;
  .result-icon {
    display: block;
    width: 1.6rem;
    height: 1.6rem;
    margin: 1.3rem auto 0.44rem;
  }
  .result-title {
    width: 5.24rem;
    margin: 0 auto;
    font-size: 0.44rem;
    color: #323233;
    font-weight: 900;
    text-align: center;
  }
  .result-desc {
    width: 5.24rem;
    margin: 0.32rem auto 0;
    font-size: 0.28rem;
    color: #a2a3a6;
    font-weight: 300;
    text-align: center;
  }
  .result-footer {
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 0.36rem;
    width: 100%;
    height: 1.06rem;
    margin-top: 0.2rem;
    font-size: 0.32rem;
    .result-btn-download {
      width: 100%;
      margin: 0 0.32rem;
      line-height: 1.06rem;
      text-align: center;
      border-radius: 2px;
    }
  }
}
</style>

